import script from "./PUTT_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./PUTT_Items.vue?vue&type=script&setup=true&lang=ts"

import "./PUTT_Items.vue?vue&type=style&index=0&id=67fd797f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fd797f"]])

export default __exports__